import qccapis from "../../api/qcc";
import apis from "../../api/index";
import flowapis from "../../api/flow";
import {dateUtils} from "../../utils/dateUtils";
import {utils} from "../../utils/utils";

export default {
    name: "BankBossAudit",
    props: {
        visible: {
            type: Boolean,
            require: false
        },
        propsOne: String
    },
    data() {
        return {
            activeName: 'first',
            activeNameZx: 'first',
            scrollHeight: 400,
            query: {
                userName: "",
            },
            isVisible: this.visible,
            detailResult: {},
            caseResult:["","","",""],
            dataShow:false,
            sxdataList:[],
            sxdata:[],
            sxtype:0,
            labelList:["失信被执行","被执行","严重违法","裁判文书"],
            AllData:[[],[],[],[]],
            pageIndex:1,
            pageSize:10,
            mlShow:false,

            llTableData: [],
            cllTableData: [],
            llListResult: [],
            llShow: false,
            cllShow: false,
            llquery: false,
            credit: {num: "暂无", comment: "暂无"},
            flowInfo: {},
            fileList: [],
            fileList_FJ: [],
            picList: [],
            flowLogs:[],
            reasonVisible: false,
            queryTime: dateUtils.dateToStr("yyyy-MM-dd hh:mm:00", new Date()),
            dialogImageUrl: '',
            dialogVisible: false,
            disabled: false,
            stepsStatus: 2,
            errorflag: false,
            secondBusinessTitle:'二级业务',
            loanApply:{
                ApplyID:'',
                UserId:'',
                Phone:'',
                PersonCompanyText:'',
                PersonCompanyFlag:'',
                PersonCompanyKey:'',
                LoanTipsId:'',
                Money:'',
                CreateTime:'',
                BankID:'',
                BankSiteID:'',
                SiteDirectorID:'',
                FirstBusiness:'',
                SecondBusiness:'',
                PeopleCount:'',
                LastYearIncome:'',
                LastYearTax:'',
                LastYearProfit:'',
            },
            loanAudit: {
                Id:null,
                Business:null,
                BusinessDetail:null,
                RiskSharing:null,
                LoanCode:null,
                LoanRate:null,
                State:null,
                LoanMonth:null,
                FristInquirer:null,
                SecondInquirer:null,
                Category:null,
                hknl_value3:null,
                CreditRating:null,
                TotalAssets:null,
                AssetCoverage:null,
                SaleProceeds:null,
                NetProfits:null,
                Ratal:null,
                LoanBalance:null,
                GuaranteeType:3,
                Guarantor:null,
                GuarantorCode:null,
                CustomProperty:null,
                CustomType:null,
                ReturnMoneyStatus:null,
                GuaranteeLetterTime:null,
                LoanEndTime:null,
                LoanMoney:null,
                EntrustedGuarantee:null,
                AccountManager:null,
                AccountManagerPhone:null,
                ProTypeId:null,
                Area:null,
                GuaranteeRate:null,
                xyzk_value5:null,
                xyzk_value4:null,
                xyzk_value3:null,
                xyzk_value2:null,
                xyzk_value1:null,
                hknl_value1:null,
                hknl_value2:null,
                dbcs_value1:null,
                dbcs_value2:1,
                hknl_value3:null
            },
            scorelist:[0,0,0,0,0,0],
            zxbglist:[],
            loanMortgage: [],
            loanCredit: {
                Id: null,
                keyword: null,
                num: null,
                createTime: null,
                danwei: null,
                money: null,
                comment2: null,
                comment2_gm: null,
                comment2_xy: null,
                comment2_js: null,
                comment: null,
                comment_xy: null,
                comment_gm: null,
                comment_js: null
            },
            loanCreditArea: {
                Id: null,
                keyword: null,
                name: null,
                area: null,
            },
            contractObj:null,
            bankInfoObj:{},
            xyzk_list1:[{value:1,label:"无任何逾期"},
          {value:2, label:"轻微逾期，已结清"},
          {value:3, label:"多次逾期，无严重违约"},
          {value:4,label:"严重逾期或当前逾期"},
          {value:0,label:"无数据"},
        ],
        xyzk_list2:[{value:1,label:"近半年征信查询小于5次"},
          {value:2, label:"近半年征信贷款查询5-10次"},
          {value:3, label:"近半年征信贷款查询10次以上"},
          {value:0,label:"无数据"},
        ],
        xyzk_list3:[{value:1,label:"无诉讼记录"},
          {value:2, label:"已结案小额诉讼"},
          {value:3, label:"多未结案或大额诉讼"},
          {value:4,label:"频繁涉及诉讼"},
          {value:0,label:"无数据"},
        ],
        xyzk_list4:[{value:1,label:"已婚本地有房"},
          {value:2, label:"未婚本地有房"},
          {value:3, label:"已婚本地无房"},
          {value:4,label:"未婚本地无房"},
          {value:0,label:"无数据"},
        ],
        xyzk_list5:[{value:1,label:"经营稳定，盈利良好"},
          {value:2, label:"经营一般，盈利波动"},
          {value:3, label:"经营困难，当年亏损"},
          {value:4,label:"经营困难，连续亏损"},
          {value:0,label:"无数据"},
        ],
        hknl_list1:[{value:1,label:"资产负债率低"},
        {value:2, label:"资产负债率适中"},
        {value:3, label:"资产负债率偏高"},
        {value:4,label:"资产负债率过高"},
        {value:0,label:"无数据"},
        ],
        hknl_list2:[{value:1,label:"收入稳定，现金流充足"},
        {value:2, label:"收入一般，现金流尚可"},
        {value:3, label:"收入波动，现金流紧张"},
        {value:0,label:"无数据"},
        ],
        hknl_list3:[{value:1,label:"便于流通变现价值高于贷款金额"},
        {value:2, label:"便于流通变现价值低于贷款金额"},
        {value:3, label:"不便于流通变现"},
        {value:4, label:"无法办理正式抵押登记手续且不便于流通变现"},
        {value:5, label:"无法办理正式抵押登记手续且不便于流通变现"},
        {value:0,label:"无数据"},
        ],
        dbcs_list1:[{value:1,label:"信用优秀，担保能力强"},
        {value:2, label:"信用良好，担保能力适中"},
        {value:3, label:"信用一般，担保能力较弱"},
        {value:4,label:"信用较差，担保能力有限"},
        {value:5,label:"非有效担保人"},
        {value:0,label:"无数据"},
        ],
        dbcs_list2:[{value:1,label:"正式抵押+保证人"},
        {value:2, label:"正式抵押"},
        {value:3, label:"保证人"},
        {value:4, label:"无保证人或抵押物"},
        {value:0,label:"无数据"},
        ],
            rules: {
              LoanYear: [
                  { required: true, message: '请填写担保函年份', trigger: 'change' },
              ],
              LoanTime:[
                  { required: true, message: '请填写担保函序号', trigger: 'change' },
              ]
            }
        };
    },
    beforeCreate: function () {
        let meta = this.$route.meta
        if (meta && meta.permBtns.length > 0) {
            this.permBtns = meta.permBtns
        }
    },
    created() {
    },
    mounted() {
        let that = this;
        that.calcTableHeight();
        // 注：window.onresize只能在项目内触发1次
        window.onresize = function windowResize() {
            that.calcTableHeight();
        }
    },
    methods: {
        onChangeClose() {
            this.isVisible = false
        },
        onChangeOpen() {
            this.isVisible = true
        },
        queryClick(flag){
            this.dataShow=true;
            this.sxtype=flag;
            if(this.caseResult[flag]>10)this.mlShow=true;
            else this.mlShow=false;
            this.pageIndex=1;
            this.sxdataList=this.getlistten(this.AllData[flag],1,10);
          },
          getlistten(list,pageIndex,pageSize){
            var newlist=[]
            for(var i=0;i<pageSize;i++){
              var j=i+(pageIndex-1)*pageSize;
              if(j<list.length)newlist.push(list[j]);
            }
            return newlist;
          },
          getList(flag){
            var type=this.sxtype;
            var that=this;
            var pageIndex=this.pageIndex+flag;
            if(pageIndex<1){that.$message.info("已经是第一页");return;}
            var allPage=(this.caseResult[this.sxtype]+9)/10;
            if(pageIndex>allPage){that.$message.info("已经是最后一页");return;};
            if(this.sxtype==2){
              this.pageIndex=pageIndex;
              this.sxdataList=this.getlistten(this.AllData[type],pageIndex,10);
            }else{
              let param1 = {
                  id:that.flowInfo.Code,
                  pageIndex:Math.ceil(pageIndex/2),
                  type:Number(type)+1
               }
               
               qccapis.getCPCaseByType(param1).then(res => {
              if(res!=null){
                if(Number(res.Status)==200){
                    var datalist=res.Result.Data;
                    if(type==3){
                      for(var j=0;j<datalist.length;j++){
                        var roletype="";
                        if(datalist[j].IsProsecutor)roletype="原告";
                        if(datalist[j].IsDefendant)roletype="被告";
                        datalist[j].RoleType=roletype;
                        var partylist=datalist[j].PartyList;
                        for(var k=0;k<partylist.length;k++){
                           if(partylist[k].RoleType==roletype){
                            datalist[j].Statement=partylist[k].Statement
                           }
                        }
                      }
                    }
                    var danwei=pageIndex%2;
                    if(danwei==0)danwei=2;
                    that.pageIndex=pageIndex;
                    var list=that.getlistten(res.Result.Data,danwei,10);
                    that.sxdataList=list;
                  }else{
                   that.$message.error(res[i].Message)
                  }
                }else{
                 that.$message.error("查询信息失败")
               }
                });
    
    
            }
          },


        queryData(row) {
            this.scorelist=[0,0,0,0,0,0]
            this.zxbglist=[]
            this.dataShow=false;
            this.sxdata=[];

            let that = this
            if (row) {
                flowapis.getFlowById({Id: row.Id}).then((res) => {
                    this.flowInfo = res;
                    if(that.flowInfo&&that.flowInfo.GuaranteeFee){
                        that.flowInfo.GuaranteeFee = utils.deepCopy(that.flowInfo.GuaranteeFee)*1.0/100
                    }
                    if(that.flowInfo&&that.flowInfo.FinalMoney){
                        that.flowInfo.FinalMoney = utils.deepCopy(that.flowInfo.FinalMoney)*1.0/1000000
                    }

                    if (res.State == 4) {
                        this.errorflag = true;
                    }else{
                        this.errorflag = false;
                    }
                    let route = Number(this.flowInfo.Route)
                    let status = Number(this.flowInfo.Status)
                    let fee =   Number(this.flowInfo.GuaranteeFee)
                    this.changeSecondBusinessShow(this.flowInfo.FirstBusiness)
                    if (res.Type === 1) {
                        // type1：1-5-6-7-8-(9-10)-11-12-13
                        switch (route) {
                            case 1:
                                this.stepsStatus = 1
                                break;
                            case 5:
                                this.stepsStatus = 2
                                break;
                            case 6:
                                this.stepsStatus = 3
                                if(res.State == 4){
                                    this.stepsStatus = this.stepsStatus -1
                                }
                                break;
                            case 7:
                                this.stepsStatus = 4
                                if(res.State == 4){
                                    this.stepsStatus = this.stepsStatus -1
                                }
                                break;
                            case 8:
                                this.stepsStatus = 5
                                if(res.State == 4){
                                    this.stepsStatus = this.stepsStatus -1
                                }
                                break;
                            case 9:
                                this.stepsStatus = 6
                                break;
                            case 10:
                                this.stepsStatus = 7
                                break;
                            case 11:
                                if(fee>0){
                                    this.stepsStatus = 8
                                }else{
                                    this.stepsStatus = 6
                                }
                                if(res.State == 4){
                                    this.stepsStatus = this.stepsStatus -1
                                }
                                break;
                            case 12:
                                if(fee>0) {
                                    this.stepsStatus = 9
                                }else{
                                    this.stepsStatus = 7
                                }
                                break;
                            case 13:
                                if(fee>0){
                                    this.stepsStatus = 10
                                }else{
                                    this.stepsStatus = 8
                                }
                                break;
                        }
                        if(status===5){
                            //代表完成了
                            if(fee>0){
                                this.stepsStatus = 10
                            }else{
                                this.stepsStatus = 8
                            }
                        }
                    } else if (res.Type === 2) {
                        // type2：1-2-3-4-5-6-7-8-(9-10)-11-12-13
                        switch (route) {
                            case 1:
                                this.stepsStatus = 1
                                break;
                            case 2:
                                this.stepsStatus = 2
                                break;
                            case 3:
                                this.stepsStatus = 3
                                if(res.State == 4){
                                    this.stepsStatus = this.stepsStatus -1
                                }
                                break;
                            case 4:
                                this.stepsStatus = 4
                                if(res.State == 4){
                                    this.stepsStatus = this.stepsStatus -1
                                }
                                break;
                            case 5:
                                this.stepsStatus = 5
                                break;
                            case 6:
                                this.stepsStatus = 6
                                if(res.State == 4){
                                    this.stepsStatus = this.stepsStatus -1
                                }
                                break;
                            case 7:
                                this.stepsStatus = 7
                                if(res.State == 4){
                                    this.stepsStatus = this.stepsStatus -1
                                }
                                break;
                            case 8:
                                this.stepsStatus = 8
                                if(res.State == 4){
                                    this.stepsStatus = this.stepsStatus -1
                                }
                                break;
                            case 9:
                                this.stepsStatus = 9
                                break;
                            case 10:
                                this.stepsStatus = 10
                                break;
                            case 11:
                                if(fee>0){
                                    this.stepsStatus = 11
                                }else{
                                    this.stepsStatus = 9
                                }
                                if(res.State == 4){
                                    this.stepsStatus = this.stepsStatus -1
                                }
                                break;
                            case 12:
                                if(fee>0) {
                                    this.stepsStatus = 12
                                }else{
                                    this.stepsStatus = 10
                                }
                                break;
                            case 13:
                                if(fee>0){
                                    this.stepsStatus = 13
                                }else{
                                    this.stepsStatus = 11
                                }
                                break;
                        }
                        if(status===5){
                            //代表完成了
                            if(fee>0){
                                this.stepsStatus = 13
                            }else{
                                this.stepsStatus = 11
                            }
                        }
                    } else if (res.Type === 3) {
                        // type3：1-3-4-5-6-7-8-(9-10)-11-12-13
                        switch (route) {
                            case 1:
                                this.stepsStatus = 1
                                break;
                            case 3:
                                this.stepsStatus = 2
                                if(res.State == 4){
                                    this.stepsStatus = this.stepsStatus -1
                                }
                                break;
                            case 4:
                                this.stepsStatus = 3
                                if(res.State == 4){
                                    this.stepsStatus = this.stepsStatus -1
                                }
                                break;
                            case 5:
                                this.stepsStatus = 4
                                break;
                            case 6:
                                this.stepsStatus = 5
                                if(res.State == 4){
                                    this.stepsStatus = this.stepsStatus -1
                                }
                                break;
                            case 7:
                                this.stepsStatus = 6
                                if(res.State == 4){
                                    this.stepsStatus = this.stepsStatus -1
                                }
                                break;
                            case 8:
                                this.stepsStatus = 7
                                if(res.State == 4){
                                    this.stepsStatus = this.stepsStatus -1
                                }
                                break;
                            case 9:
                                this.stepsStatus = 8
                                break;
                            case 10:
                                this.stepsStatus = 9
                                break;
                            case 11:
                                if(fee>0){
                                    this.stepsStatus = 10
                                }else{
                                    this.stepsStatus = 8
                                }
                                if(res.State == 4){
                                    this.stepsStatus = this.stepsStatus -1
                                }
                                break;
                            case 12:
                                if(fee>0) {
                                    this.stepsStatus = 11
                                }else{
                                    this.stepsStatus = 9
                                }
                                break;
                            case 13:
                                if(fee>0){
                                    this.stepsStatus = 12
                                }else{
                                    this.stepsStatus = 10
                                }
                                break;
                        }
                        if(status===5){
                            //代表完成了
                            if(fee>0){
                                this.stepsStatus = 12
                            }else{
                                this.stepsStatus = 10
                            }
                        }
                    } else if (res.Type === 4) {
                        //type4：1-6-7-8-(10)-11-12-13
                        switch (route) {
                            case 1:
                                this.stepsStatus = 1
                                break;
                            case 6:
                                this.stepsStatus = 2
                                if(res.State == 4){
                                    this.stepsStatus = this.stepsStatus -1
                                }
                                break;
                            case 7:
                                this.stepsStatus = 3
                                if(res.State == 4){
                                    this.stepsStatus = this.stepsStatus -1
                                }
                                break;
                            case 8:
                                this.stepsStatus = 4
                                if(res.State == 4){
                                    this.stepsStatus = this.stepsStatus -1
                                }
                                break;
                            case 10:
                                this.stepsStatus = 5
                                if(res.State == 4){
                                    this.stepsStatus = this.stepsStatus - 1;
                                }
                                break;
                            case 11:
                                if(fee>0){
                                    this.stepsStatus = 6
                                }else{
                                    this.stepsStatus = 5
                                }
                                if(res.State == 4){
                                    this.stepsStatus = this.stepsStatus -1
                                }
                                break;
                            case 12:
                                if(fee>0){
                                    this.stepsStatus = 7
                                }else{
                                    this.stepsStatus = 6
                                }
                                if(res.State == 4){
                                    this.stepsStatus = this.stepsStatus -1
                                }
                                break;
                            case 13:
                                if(fee>0){
                                    this.stepsStatus = 8
                                }else{
                                    this.stepsStatus = 7
                                }
                                break;
                        }
                        if(status===5){
                            if(fee>0){
                                this.stepsStatus = 8
                            }else{
                                this.stepsStatus = 7
                            }
                        }
                    }

                    // 查询营业执照
                    const yyzz = qccapis.getCPDetail({id: res.Code})
                    // 诉讼信息
                    const ssxx = qccapis.getCPCase({id:  res.Code})
                    // 查询老赖信息
                     const llxx = qccapis.getLL({idCard:res.IdCard})
                    // 查询流程文件
                    const lcfiles = flowapis.getLoanFiles({processId: res.Id,uploadType:'1'})

                    const logs = flowapis.getFlowLogByFlowId({flowId:res.Id})

                    // 查询审核信息
                    const shxx = flowapis.getLoanAuditInfo({
                            flowId:that.flowInfo.Id,
                            applyId: res.ApplyID,
                            auditId: res.AuditID,
                            IdCard:that.flowInfo.IdCard
                        }
                    )

                    const fileInfo = flowapis.getLoanFiles({processId:that.flowInfo.Id,type:'2',uploadType:'2'})


                    // // 查询政务信息
                    // const promise3 =
                    // yyzz, ssxx , llxx,llxx2,shxx
                    Promise.all([yyzz, ssxx,shxx, lcfiles, logs,fileInfo,llxx]).then((res) => {
                        if (res.length === 7) {
                            if(res[0]&&res[0]['Result']){
                                that.detailResult = res[0]['Result']
                            }else{
                                that.detailResult = {}
                            }
                            var qccres=res[1];
                            if(qccres){
                                that.sxdata=res;
                                for(var i=0;i<4;i++){
                                    if(Number(qccres[i].Status)==200){
                                      if(qccres[i].Result.VerifyResult==0)that.caseResult[i]=0;
                                      else {
                                        if(i<2)that.caseResult[i] = qccres[i].Paging.TotalRecords;
                                        if(i==2)that.caseResult[i]=qccres[i].Result.Data.length;
                                        if(i==3){
                                          that.caseResult[i] = qccres[i].Paging.TotalRecords;
                                         var datalist=qccres[3].Result.Data;
                                          for(var j=0;j<datalist.length;j++){
                                            var roletype="";
                                            if(datalist[j].IsProsecutor)roletype="原告";
                                            if(datalist[j].IsDefendant)roletype="被告";
                                            datalist[j].RoleType=roletype;
                                            var partylist=datalist[j].PartyList;
                                            for(var k=0;k<partylist.length;k++){
                                               if(partylist[k].RoleType==roletype){
                                                datalist[j].Statement=partylist[k].Statement
                                               }
                                            }
                                          }
                                        }
                                        that.AllData[i]=that.AllData[i].concat(qccres[i].Result.Data);
                                        if(!that.dataShow){
                                             that.dataShow=true;
                                             that.sxtype=i;
                                             that.sxdataList=that.getlistten(qccres[i].Result.Data,1,10);
                                             if(that.caseResult[i]>10)that.mlShow=true;
                                        }
                  
                                      }
                                  }else{
                                    that.caseResult[i]="";
                                  }
                                 }
                            }
                        

                            if(res[2]){
                                if(res[2].applyObj){
                                that.loanApply = res[2].applyObj
                                that.changeSecondBusinessShow(that.loanApply.FirstBusiness)
                                }else{
                                that.setEmptyApply()
                                }
                                if(res[2].auditObj){
                                that.loanAudit = res[2].auditObj
                                if(that.loanAudit.GuaranteeLetterTime){
                                    that.loanAudit.GuaranteeLetterTime = new Date(that.loanAudit.GuaranteeLetterTime)
                                }
                                if(that.loanAudit.LoanEndTime){
                                    that.loanAudit.LoanEndTime= new Date(that.loanAudit.LoanEndTime)
                                }
                                if(that.loanAudit.LoanMoney){
                                    that.loanAudit.LoanMoney = Math.floor(that.loanAudit.LoanMoney*1.0)/100.0
                                }
                                if(that.loanAudit.scoreList){
                                    that.scorelist = that.loanAudit.scoreList.split(",")
                                }
                                if(that.loanAudit.zxbgList){
                                    that.zxbglist = JSON.parse(that.loanAudit.zxbgList)
                                }
                                if(that.loanAudit.ThirdBusiness){
                                    that.loanAudit.ThirdBusiness=that.loanAudit.ThirdBusiness.toString().split(",");
                                  }else{
                                    that.loanAudit.BusinessDetail=that.loanApply.SecondBusiness
                                    that.loanAudit.Business=that.loanApply.FirstBusiness
                                    that.loanAudit.ThirdBusiness=that.loanApply.ThirdBusiness==null?[]:that.loanApply.ThirdBusiness.toString().split(",");
                                  }
                                }else{
                                that.setEmptyAudit()
                                that.loanAudit.BusinessDetail=that.loanApply.SecondBusiness
                                that.loanAudit.Business=that.loanApply.FirstBusiness
                                that.loanAudit.ThirdBusiness=that.loanApply.ThirdBusiness==null?[]:that.loanApply.ThirdBusiness.toString().split(",");
                                }
                                if(res[2].contractObj){
                                    that.contractObj = res[2].contractObj
                                }
                                if(res[2].mortgageObj){
                                that.loanMortgage = res[2].mortgageObj
                                }else{
                                that.loanMortgage = []
                                }
                                if(res[2].proTypeList){
                                that.proTypeList = res[2].proTypeList
                                that.setDbInfo()
                                }else{
                                that.proTypeList = []
                                }
                                if(res[2].bankInfoObj){
                                that.bankInfoObj = res[2].bankInfoObj
                                }else{
                                that.bankInfoObj = {}
                                }
                                if(res[2].loanCreditObj){
                                that.loanCredit = res[2].loanCreditObj
                                }else{
                                that.setEmptyCredit()
                                }
                                if(res[2].loanCreditAreaObj){
                                that.loanCreditArea = res[2].loanCreditAreaObj
                                }else{
                                that.setEmptyCreditArea()
                                }
                            }else{
                                that.setEmptyApply()
                                that.setEmptyAudit()
                                that.loanMortgage = []
                                that.setEmptyCredit()
                                that.setEmptyCreditArea()
                            }
                            if (res[3] && res[3].length > 0) {
                                that.picList = []
                                that.fileList = []
                                for (let f = 0; f < res[3].length; f++) {
                                    if (res[3][f]['Type'] + '' === '1') {
                                        that.picList.push({
                                            name: res[3][f]['Name'],
                                            url: res[3][f]['Url']
                                        })
                                    } else {
                                        that.fileList.push({
                                            name: res[3][f]['Name'],
                                            url: res[3][f]['Url']
                                        })
                                    }
                                }
                            } else {
                                that.fileList = []
                                that.picList = []
                            }
                            if(res[4]){
                                that.flowLogs = res[4]
                            }
                            if(res[5]&&res[5].length>0){
                                that.fileList_FJ = []
                                for(let f=0;f<res[5].length;f++){
                                  that.fileList_FJ.push({
                                    name:res[5][f]['Name'],
                                    url:res[5][f]['Url']
                                  })
                                  
                                }
                              }else{
                                that.fileList_FJ = []
                              }
                              if(res[6]){
                                that.llTableData=res[6].list;
                            }
                        }
                    })


                })
            }
        },
        beforeAvatarPicUpload(file) {
            let that = this
            const isJPG =
                file.type === "image/jpg" ||
                file.type === "image/jpeg" ||
                file.type === "image/png"
            const isLt2M = file.size / 1024 / 1024 < 2
            if (!isJPG) {
                that.$message.error("仅支持jpg、png格式的图片")
            }
            if (!isLt2M) {
                that.$message.error("上传图片大小不能超过2MB")
            }
            return isJPG && isLt2M
        },
        uploadPicFile(item) {
            let that = this
            let fileObj = item.file
            const form = new FormData()
            form.append("file", fileObj)
            apis.uploadFile(form).then(res => {
                that.picList.push({
                    name: that.getFileName(res.fullPath),
                    url: res.fullPath
                })
            });
        },
        beforeAvatarFileUpload(file) {
            let that = this
            const isLt2M = file.size / 1024 / 1024 < 10
            if (!isLt2M) {
                that.$message.error("上传文件大小不能超过10MB")
            }
            return true
        },
        uploadFileFile(item) {
            let that = this
            let fileObj = item.file
            const form = new FormData()
            form.append("file", fileObj)
            apis.uploadFile(form).then(res => {
                that.fileList.push({
                    name: that.getFileName(res.fullPath),
                    url: res.fullPath
                })
            });
        },
        getFileName(path) {
            var pos1 = path.lastIndexOf('/');
            var pos2 = path.lastIndexOf('\\');
            var pos = Math.max(pos1, pos2)
            if (pos < 0)
                return path;
            else
                return path.substring(pos + 1);
        },
        handlePicRemove(file) {
            let that = this
            if (file) {
                for (let i = 0; i < that.picList.length; i++) {
                    if (file.url === that.picList[i].url) {
                        that.picList.splice(i, 1)
                    }
                }
            }
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        handlePicDownload(file) {
            if (file) {
                const blob = new Blob([file.url], {type: 'application/vnd.ms-excel'})
                const elink = document.createElement('a')
                elink.download = file.name
                elink.style.display = 'none'
                elink.href = URL.createObjectURL(blob)
                document.body.appendChild(elink)
                elink.click()
                URL.revokeObjectURL(elink.href)
                document.body.removeChild(elink)
            }
        },
        /**
         * 银行拒绝通过
         */
        onReturnFlow() {
            let that = this
            this.$prompt('', '必须填写拒绝的原因', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputErrorMessage: '必须填写原因',
                inputValidator: (value) => {
                    if (value.trim().length < 1) {
                        return false
                    }
                },
                beforeClose: (action, instance, done) => {
                    if (action == 'confirm') {
                        let value = instance.inputValue
                        if (value && value != '') {
                            let param = {
                                Id: that.flowInfo.Id,
                                Route: 4,
                                RefuseReason: value,
                                BankID: that.flowInfo.BankID,
                                State: '4',
                                RefuseType: '2'
                            }
                            flowapis.updateFlow(param).then((res) => {
                                if (res && res.code) {
                                    done()
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: "error"
                                    });
                                }
                            })
                        }
                    } else {
                        done()
                    }
                }
            }).then(({value}) => {
                that.$emit('bankbossauditsucess');
                that.onChangeClose()
            }).catch(() => {

            });
        },
        calcTableHeight() {
            this.$nextTick(() => {
                var height1 = $(".content-box .content").height();
                var height = height1 - 150 - 20;
                this.scrollHeight = height;
            });
        },
        setEmptyApply(){
            let that = this
            that.loanApply = {
                ApplyID:'',
                UserId:'',
                Phone:'',
                PersonCompanyText:'',
                PersonCompanyFlag:'',
                PersonCompanyKey:'',
                LoanTipsId:'',
                Money:'',
                CreateTime:'',
                BankID:'',
                BankSiteID:'',
                SiteDirectorID:'',
                FirstBusiness:'',
                SecondBusiness:'',
                PeopleCount:'',
                LastYearIncome:'',
                LastYearTax:'',
                LastYearProfit:'',
            }
        },
        setEmptyAudit(){
            let that = this
            that.loanAudit = {
                Id:null,
                Business:null,
                BusinessDetail:null,
                RiskSharing:null,
                LoanCode:null,
                LoanRate:null,
                State:null,
                LoanMonth:null,
                FristInquirer:null,
                SecondInquirer:null,
                Category:null,
                hknl_value3:null,
                CreditRating:null,
                TotalAssets:null,
                AssetCoverage:null,
                SaleProceeds:null,
                NetProfits:null,
                Ratal:null,
                LoanBalance:null,
                GuaranteeType:3,
                Guarantor:null,
                GuarantorCode:null,
                CustomProperty:null,
                CustomType:null,
                ReturnMoneyStatus:null,
                GuaranteeLetterTime:null,
                LoanEndTime:null,
                LoanMoney:null,
                EntrustedGuarantee:null,
                AccountManager:null,
                AccountManagerPhone:null,
                ProTypeName:null,
                Area:null,
                GuaranteeRate:null,
                xyzk_value5:null,
                xyzk_value4:null,
                xyzk_value3:null,
                xyzk_value2:null,
                xyzk_value1:null,
                hknl_value1:null,
                hknl_value2:null,
                dbcs_value1:null,
                dbcs_value2:1,
                hknl_value3:null
            }
            this.scorelist=[0,0,0,0,0,0],
            this.zxbglist=[]
        },
        setEmptyCredit(){
            let that = this
            that.loanCredit = {
              Id:null,
              keyword:null,
              num:null,
              createTime:null,
              danwei:null,
              money:null,
              comment2:null,
              comment2_gm:null,
              comment2_xy:null,
              comment2_js:null,
              comment:null,
              comment_xy:null,
              comment_gm:null,
              comment_js:null
            }
        },
        setEmptyCreditArea(){
            let that = this
            that.loanCreditArea = {
              Id:null,
              keyword:null,
              name:null,
              area:null,
            }
        },
        setDbInfo(){
            // let that = this
            // for(let i=0;i<that.proTypeList.length;i++){
            //   if(that.proTypeList[i]["ProTypeName"]===that.loanAudit.ProTypeName){
            //     that.dbfl = that.proTypeList[i]['GuaranteeRate']
            //     that.xmfxbl = that.proTypeList[i]['RiskRate']
            //     break
            //   }
            // }
        },
        /**
         * 银行通过
         */
        toViewUrl(type) {
            if (type == 1) {
                window.open(this.flowInfo.ViewUrl)
                if (this.flowInfo.cpViewUrl) window.open(this.flowInfo.cpViewUrl)
            } else {
                window.open(this.flowInfo.DownLoadUrl)
                if (this.flowInfo.cpDownLaodUrl) window.open(this.flowInfo.cpDownLaodUrl)
            }
        },
        changeSecondBusinessShow(value) {
            switch (value) {
                case '电商':
                    this.secondBusinessTitle = '销售类目'
                    break;
                case '种植':
                    this.secondBusinessTitle = '种植作物'
                    break;
                case '养殖':
                    this.secondBusinessTitle = '养殖种类'
                    break;
                case '农产品加工':
                    this.secondBusinessTitle = '加工品类'
                    break;
                case '农资农机销售':
                    this.secondBusinessTitle = '销售品类'
                    break;
                case '农产品购销':
                    this.secondBusinessTitle = '产品类型'
                    break;
                case '农业服务':
                    this.secondBusinessTitle = '服务项目'
                    break;
                case '农业旅游农家乐':
                    this.secondBusinessTitle = '产业类型'
                    break;
                case '农业相关工程':
                    this.secondBusinessTitle = '工程内容'
                    break;
                case '其他':
                    this.secondBusinessTitle = '经营项目'
                    break;
            }
        },
        onDownChange(path){
          window.open(path)
        }
    },
};
